import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

// Toast
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

// Vuetify
import "@mdi/font/css/materialdesignicons.css"
import 'vuetify/styles'
import { createVuetify } from 'vuetify/lib/framework.mjs'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VTimePicker } from 'vuetify/labs/VTimePicker'

import DateFnsAdapter from "@date-io/date-fns"
import { es as esDateFns } from 'date-fns/locale'

import 'reflect-metadata';

const vuetify = createVuetify({
    components: {...components, VTimePicker},
    directives,
    date: {
        adapter: DateFnsAdapter,
        locale: {
            es: esDateFns,
        }
    },
    locale: {
        locale: 'es',
    },
})

// Pinia
import { createPinia } from 'pinia'
const pinia = createPinia()

createApp(App)
    .use(router)
    .use(vuetify)
    .use(pinia)
    .use(ToastPlugin)
    .mount('#app')
